<template>
  <v-container fluid grid-list-md class="bot-add-user">
    <div class="headline ma-3 text-color-vip bold">
      Buf Like , Sub Tây
    </div>
    <div class="container-tabs" v-if="maintain">
      <h1 class="maintain_notice">Job này đang bảo trì</h1>
    </div>
    <v-layout row wrap v-else>
      <v-tabs :background-color="COLOR.BG_MAIN_COLOR">
        <v-tab href="#create-process" active-class="text-color">Tạo tiến trình</v-tab>
        <v-tab href="#activity-log"  active-class="text-color">Nhật ký Order</v-tab>
        <v-tab-item value="create-process">
          <LikeSubCommentTayProcess />
        </v-tab-item>
        <v-tab-item value="activity-log">
          <LikeSubCommentTayLog />
        </v-tab-item>
      </v-tabs>
    </v-layout>
  </v-container>
</template>
<script>
    import { COLOR, SEEDING_TYPE } from "~/config/constant";
    import LikeSubCommentTayProcess from "~/components/like-sub-comment-tay/LikeSubCommentTayProcess";
    import LikeSubCommentTayLog from "~/components/like-sub-comment-tay/LikeSubCommentTayLog";
    import {
        SEEDING_TYPE_MAINTAIN,
    } from "~/store/actions.type";
    export default {
        components: {
            LikeSubCommentTayProcess,
            LikeSubCommentTayLog
        },
        data() {
            return {
                COLOR: COLOR,
                maintain: false,
            }
        },
        methods: {
            async getDataFromApi() {
                this.overlay = true
                let dataInfo = await this.$store.dispatch(SEEDING_TYPE_MAINTAIN);
                if (dataInfo.includes(SEEDING_TYPE.ID_SUB_TAY) || dataInfo.includes(SEEDING_TYPE.ID_LIKE_POST_TAY) || dataInfo.includes(SEEDING_TYPE.ID_LIKE_FANPAGE_TAY)) {
                    this.maintain = true;
                }
                this.overlay = false
            },
        },
        created() {
            this.getDataFromApi()
        }
    }
</script>